import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { BillingInvoicesRedirectBusinessService } from './billing-invoices-redirect-business.service';

@Component({
  standalone: false,
  selector: 'gh-billing-invoices-redirect',
  template: `
    <div class="page-loading-spinner">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Redirecting to billing...</p>
    </div>
  `,
  styles: [`
    .page-loading-spinner {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 200px;
    }
  `]
})
export class BillingInvoicesRedirectComponent implements OnInit {

  constructor(
    private billingInvoicesBusiness: BillingInvoicesRedirectBusinessService,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.billingInvoicesBusiness.redirectToBilling();
    this.location.back();
  }
}